import { get } from 'lodash';
import { isIosBridge } from './helpers';

class IosBridgeService {
  static initializeWVJB(callback) {
    window.WVJBCallbacks = [callback];
    const WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'https://__bridge_loaded__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(() => {
      document.documentElement.removeChild(WVJBIframe);
    }, 0);
  }

  static setupBridge(callback) {
    if (window.WKWebViewJavascriptBridge) {
      callback(window.WKWebViewJavascriptBridge);
      return;
    }

    if (window.WKWVJBCallbacks) {
      window.WKWVJBCallbacks.push(callback);
      return;
    }

    window.WKWVJBCallbacks = [callback];
    if (get(window, 'webkit.messageHandlers.iOS_Native_InjectJavascript')) {
      window.webkit.messageHandlers.iOS_Native_InjectJavascript.postMessage(null);
      return;
    }

    this.initializeWVJB(callback);
  }

  constructor() {
    this.initialized = false;
    this.bridge = {
      callHandler: () => null,
      registerHandler: () => null,
    };

    if (isIosBridge()) {
      IosBridgeService.setupBridge((webBridge) => {
        this.bridge = webBridge;
        this.initialized = true;
        this.callHandler('bridge://initialized');
      });
    }
  }

  callHandler(name, data, cb) {
    this.bridge.callHandler(name, data, cb);
  }

  registerHandler(name, callback) {
    this.bridge.registerHandler(name, callback);
  }

  isInitialized() {
    return this.initialized;
  }
}


export default new IosBridgeService();
